// 日本语言
export const common = {
  cancel:"キャンセル",
  confirm:"かくにん",
  country:"国"
};
// 订单列表页面
export const orderList = {
  title:"受注リスト",
};

// 查询页面
export const cardLoop = {
  cardTitle:"SIMカードICCID番号",
  cardDesc:"入力ボックスにSIMカードICCID番号を入力します。",
  query:"検索けんさく", //查询按钮
  title:"ユビキタスネットワークSIMカードプラットフォーム",
};

// 详情页面
export const cardInfo = {
  title:"カード情報",
  msisdn:"MSISDN：",
  iccid:"ICCID：",
  expiration:"有効期限：",//过期时间
  status:'ステータス',
  refresh:"リフレッシュ",//刷新
  residualFlow:"残留流",//剩余流量
  totalFlow:"合計",//总流量
  used:"有効期間",//已使用
  lists:["使用する","未使用","使用済み"],//tab切换 1 生效中 2 未生效 3.已失效
  validity:"有効期間",//套餐有效期
  skuUsed:"使用済み",//套餐已用
  skuTotal:"合計",//套餐总量
  recharge:"再充電",//去充值
};

// 选套餐页面
export const cardPlans = {
  title:"セットリスト",
  buyPlan:"購入計画",
  select:"選択されていない",//未选套餐的提示
  orderList:"受注リスト",
  userAgreement:"ユーザプロトコル",
  price:"セット価格",
  flowCount:"ぜんりゅうりょう",
  validityTime:"有効日",
  switchCountryName:"使用可能領域",
  productDesc:"コースの説明",
  productDescText:"前払金",
  paymentMethod:"支払い方法",
  checkUserAgreementMsg:"ユーザープロトコルをチェックしてください",
  payErrorMsg:"入金アカウントはまだ人民元の支払いを支持しません",
  payBtnText:"使用",
};


// 完成支付或取消支付
export const cardPayEnd = {
  title:"支払い結果",
  Details:"詳細",//返回详情
};

export const country = {
  America:'米国',
  HongKong:'香港',
  Thailand:'タイ',
  Philippines:'フィリピン',
  Macao:'マカオ'
}
// 位置标签
export const placeTitle = "所在国";
// 国家名称
export const China = "中国"
export const America = "アメリカ"
export const HongKong = "香港"







